module.exports = __webpack_public_path__ + "img/cover_1.6477dedc.png";